<template>
    <div class="carrierType">
        <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
            @resetFn="resetFn" @confirmFn="getListFn" @searchFn="getListFn" @AddFn="AddFn" @delFn="delFns" />
        <div class="componentPage">
            <carrierTable :tableData="tableData" :statusParam="statusParam" :loading="loading" @detailFn="detailFn"
                @delFn="delFn" @choozeTableFn="choozeTableFn" />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>
        <!-- 操作框 -->
        <carrierHandle ref="carrierHandle" :isShow.sync="isShow" :title="title" :statusParam="statusParam"
            :handleText="handleText" :customers="customers" :detailContent="detailContent" />
    </div>
</template>

<script>
import mixinForm from '@/utils/formMixins.js';
import { carrierTypeList, carrierTypeDelete, carrierTypeDetail } from '@/api/modules/carrierType.js';
import { shareParam, shareScope } from '@/api/modules/public.js';

import carrierTable from './carrierTable.vue';
import carrierHandle from './carrierHandle.vue'

export default {
    mixins: [mixinForm],
    components: {
        carrierTable,
        carrierHandle
    },
    data() {
        return {
            SearchForm: {
                name: '',
                status: ''
            },
            formContent: [
                {
                    id: 1,
                    text: $t('integration.name'),
                    type: 'input',
                    paramsName: 'name',
                    isChooze: true,
                },
                {
                    id: 2,
                    text: 'public.status',
                    type: 'select',
                    paramsName: 'status',
                    selectParam: [],
                    isChooze: false,
                }
            ],
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ["delRange"],
                    text: 'public.btn_new',
                    method: 'AddFn'
                },
                {
                    id: 2,
                    icon: '',
                    vHas: ["delRange"],
                    text: 'public.tbopt_delete',
                    method: 'delFn'
                }
            ],
            // 区分模式
            handleText: '',
            // 选中的table
            choozeTable: [],
            // 请求的状态数据源
            statusParam: [],
            // 客户值
            customers: [],
            // 详情content
            detailContent: {},
            // 编辑content
            editContent:{}

        }
    },
    created() {
        this.initPatam();
    },
    methods: {
        initPatam() {
            shareParam({ code: 'carrier_type_status', type: 0 }).then(({ result }) => {
                // this.formContent[1].selectParam = result
                let array = [{ value: '', label: 'public.please' }]
                this.statusParam = array.concat(result.map((item) => {
                    return {
                        value: item.code,
                        label: 'public.' + item.content,
                    }
                }))
                this.formContent[1].selectParam = this.statusParam;
            })
        },
        resetFn() {
            this.SearchForm = {
                name: '',
                status: '',
                iDisplayStart: 0,
                iDisplayLength: 15
            }
            this.getListFn();
        },
        getListFn() {
            this.loading = true;
            carrierTypeList(this.SearchForm).then(({ result, pageInfo }) => {
                this.tableData = result;
                this.total = pageInfo.total
            }).finally(() => {
                this.loading = false
            })
        },
        // 公共弹窗显示
        publicFn(title = '',bool) {
            this.isShow = true;
            this.title = title;
            this.getAppScopeFn();
            this.$nextTick(() => {
                this.$refs['carrierHandle'].activeCom = 'Attribute';
                this.$refs['carrierHandle'].isMode = bool;
                // 清除校验
                this.$refs['carrierHandle'].clearValidate();
            });
        },
        // 获取应用客户值
        getAppScopeFn() {
            if (this.customers.length > 0) return
            shareScope().then(({ result }) => {
                this.customers = result
            })
        },
        // 新增
        AddFn() {
            this.isShow = true;
            this.handleText = 'add';
            this.publicFn($t('integration.new_mount_type'),false);
        },
        detailFn(row) {
            this.publicFn($t('integration.mount_type_details'),true);
            this.handleText = 'detail';
            this.getDetailFn(row.id);
        },
        // 获取详情
        getDetailFn(id) {
            carrierTypeDetail(id).then(({ result }) => {
                this.detailContent = result;
            })
        },
        choozeTableFn(row) {
            this.choozeTable = row;
        },
        // 删除 单条
        delFn(row) {
            if (row.status === 1) return this.$message.warning($t('integration.enable_status_cannot_be_deleted'));
            this.TODOTIPDEL({ ids: row.id });
        },
        // 删除多条
        delFns() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            const flag = this.choozeTable.some(item => item.status === 1);
            if (flag) return this.$message.warning($t('integration.the_selected_data_has_an_enabled_state_and_cannot_be_deleted'));
            const ids = this.choozeTable.map(item => item.id).join(',')
            this.TODOTIPDEL({ ids });
        },
        TODOTIPDEL(param) {
            this.$confirm(
                this.$t($t('integration.deleting_a_monitoring_point_type_will_delete_all_data_under_this_type_dot__are_you_sure_you_want_to_do_this_q')),
                this.$t('public.prompt'),
                {
                    confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                    cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                    type: 'warning',
                }
            ).then(() => {
                carrierTypeDelete(param).then(({ state }) => {
                    if (state.code === 200) {
                        this.getListFn();
                        this.$message.success(
                            this.$t('public.tip_del_succ').toString()
                        )
                    }
                })
            }).catch(() => { })
        },
    }
}
</script>

<style lang="scss" scoped>
.carrierType {
    padding: 0 15px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
